module.exports = __webpack_public_path__ + "static/media/SEG FISI.179ed987.png";